/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

var taricLinks= angular.module('taric.moreinfo.links', ['taric.moreinfo.links.search']);
taricLinks.config(function ($stateProvider) {
    $stateProvider.state('taric.moreinfo', {
            abstract: true,
            url: '/moreinfo',
            template: '<ui-view></ui-view>'
        }).state('taric.moreinfo.links', {
            url: '/links',
            templateUrl: 'taric/moreinfo/links/search/links-search.tmpl.html',
            controller : 'SearchTaricLinksController as searchTaricLinksCtrl',
            resolve: {
                loadTranslation: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('taric/moreinfo/links');
                },
                setupMenu: function (MenuModel) {
                	
                	MenuModel.setHelpIndex(this.name);
                	MenuModel.notifyObservers();
                }
        }
    });

});



// WEBPACK FOOTER //
// ./app/taric/moreinfo/links/taric-links.js